// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 644 ? "d94c0b71" : chunkId) + "." + {"29":"6bf3e797c95476d9","358":"cc0294261965321f","644":"57f94a9dfd1a24ab"}[chunkId] + ".js";
};